// extracted by mini-css-extract-plugin
export default {"container":"TaskAccordion_container__K6aEj","empty":"TaskAccordion_empty__8kGvZ"};